import { jsx as _jsx } from "react/jsx-runtime";
import { SpecraEmptyState, SpecraText } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { PageBody } from '../../../../components/layout';
import { useProgramContext } from '../../../../layouts/ProgramLayout';
import { useView } from '../../../../lib/access';
import { financialSectionVisible, programRef } from '../../../../lib/access/types';
import { FinancialTab } from '../../Financial/FinancialTab';
export function FinancialPage() {
    const { programId } = useProgramContext();
    // The nav hides Financial from a viewer who can see neither figure on it
    // (financialSectionVisible); a direct URL or an old bookmark gets the same
    // answer here instead of an empty page of masked tiles.
    const view = useView(programRef(programId));
    if (view.isLoading) {
        return /*#__PURE__*/ _jsx(PageBody, {
            children: /*#__PURE__*/ _jsx(SpecraText, {
                tone: "muted",
                size: "caption",
                children: "Loading…"
            })
        });
    }
    if (!financialSectionVisible(view.fieldMasked)) {
        return /*#__PURE__*/ _jsx(PageBody, {
            children: /*#__PURE__*/ _jsx("div", {
                "data-testid": Testids.deliveryFinancial.noAccess,
                children: /*#__PURE__*/ _jsx(SpecraEmptyState, {
                    title: "Financials aren't part of your view of this program",
                    description: "Your role on this program doesn't include its funding or burn figures. Your admin can grant access."
                })
            })
        });
    }
    return /*#__PURE__*/ _jsx(PageBody, {
        children: /*#__PURE__*/ _jsx(FinancialTab, {
            programId: programId
        })
    });
}
